import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_UserAccounts_PasswordChangeRequest,
  RequestModels_UserAccounts_UsernameChangeRequest,
  UserAccounts_PushPreferencesRequestModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type SetUsernameByCustomerId = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody?: RequestModels_UserAccounts_UsernameChangeRequest;
};
/**
 * Sets the username by customer identifier.
 *
 * @returns any Success
 */
export function setUsernameByCustomerId(
  { businessUnit, label, customerId, requestBody }: SetUsernameByCustomerId,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PATCH',
      path: `/dxpweb/${businessUnit}/${label}/useraccounts/customers/${customerId}/username`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type DeleteUserAccount = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
};
/**
 * Deletes a useraccount
 *
 * @returns void
 */
export function deleteUserAccount(
  { businessUnit, label, customerId }: DeleteUserAccount,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'DELETE',
      path: `/dxpweb/${businessUnit}/${label}/useraccounts/customers/${customerId}`,
      errors: {
        400: 'When the validation is incorrect or the backend returns a functional error.',
        404: 'The customer does not have a useraccount',
      },
    },
    requestConfig,
  );
}

type ChangePasswordByCustomerId = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody?: RequestModels_UserAccounts_PasswordChangeRequest;
};
/**
 * Changes the password by customer identifier.
 *
 * @returns any Success
 */
export function changePasswordByCustomerId(
  { businessUnit, label, customerId, requestBody }: ChangePasswordByCustomerId,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PATCH',
      path: `/dxpweb/${businessUnit}/${label}/useraccounts/customers/${customerId}/password`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type RegisterPushPreferencesUserAccount = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody: UserAccounts_PushPreferencesRequestModel;
};
/**
 * Set the push preferences of a user
 *
 * @returns void
 */
export function registerPushPreferencesUserAccount(
  { businessUnit, label, customerId, requestBody }: RegisterPushPreferencesUserAccount,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/useraccounts/customers/${customerId}/pushpreferences`,
      body: requestBody,
      errors: { 400: 'When the validation is incorrect or the backend returns a functional error.' },
    },
    requestConfig,
  );
}

type CreateMandate = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
};
/**
 * Create a mandate
 *
 * @returns any Accepted if mandate has been created
 */
export function createMandate(
  { businessUnit, label, customerId }: CreateMandate,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/useraccounts/customers/${customerId}/mandate`,
      errors: { 400: 'When the validation is incorrect or the backend returns a functional error.' },
    },
    requestConfig,
  );
}
